import { FeatureFlags } from "flagged";

export const flags: FeatureFlags = {
  testFlagFE: true,
  maintenanceMode: false,
};
